import { watchDeleteLookupValue } from './deleteLookupValue';
import { watchFetchCounties } from './fetchCounties';
import { watchFetchOnDemandLookups } from './fetchOnDemandLookups';
import { watchUpdateLookupValue } from './updateLookupValue';

export const lookupSagas = [
  watchFetchCounties(),
  watchFetchOnDemandLookups(),
  watchUpdateLookupValue(),
  watchDeleteLookupValue()
];
